var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35856 2.87435C6.14933 1.78637 5.19733 1 4.08942 1H2.15536C1.51727 1 1 1.51727 1 2.15536C1 2.79345 1.51727 3.31072 2.15536 3.31072L4.08942 3.31072L6.25692 14.5817C6.67537 16.7577 8.57937 18.3304 10.7952 18.3304H17.9692C20.0686 18.3304 21.9042 16.9154 22.4385 14.8851L23.884 9.39194C24.4624 7.19414 22.8047 5.04376 20.5321 5.04376H6.77576L6.35856 2.87435ZM7.22013 7.35448L8.52606 14.1453C8.73529 15.2333 9.68729 16.0197 10.7952 16.0197H17.9692C19.0189 16.0197 19.9367 15.3122 20.2038 14.297L21.6494 8.80387C21.8422 8.07128 21.2896 7.35448 20.5321 7.35448H7.22013Z",
    fill: "#11294C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79865 22.9519C7.84152 22.9519 7.06561 22.1759 7.06561 21.2188C7.06561 20.2617 7.84152 19.4858 8.79865 19.4858C9.75578 19.4858 10.5317 20.2617 10.5317 21.2188C10.5317 22.1759 9.75578 22.9519 8.79865 22.9519Z",
    fill: "#11294C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9081 22.9519C17.9509 22.9519 17.175 22.1759 17.175 21.2188C17.175 20.2617 17.9509 19.4858 18.9081 19.4858C19.8652 19.4858 20.6411 20.2617 20.6411 21.2188C20.6411 22.1759 19.8652 22.9519 18.9081 22.9519Z",
    fill: "#11294C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35856 2.87435C6.14933 1.78637 5.19733 1 4.08942 1H2.15536C1.51727 1 1 1.51727 1 2.15536C1 2.79345 1.51727 3.31072 2.15536 3.31072L4.08942 3.31072L6.25692 14.5817C6.67537 16.7577 8.57937 18.3304 10.7952 18.3304H17.9692C20.0686 18.3304 21.9042 16.9154 22.4385 14.8851L23.884 9.39194C24.4624 7.19414 22.8047 5.04376 20.5321 5.04376H6.77576L6.35856 2.87435ZM7.22013 7.35448L8.52606 14.1453C8.73529 15.2333 9.68729 16.0197 10.7952 16.0197H17.9692C19.0189 16.0197 19.9367 15.3122 20.2038 14.297L21.6494 8.80387C21.8422 8.07128 21.2896 7.35448 20.5321 7.35448H7.22013Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79865 22.9519C7.84152 22.9519 7.06561 22.1759 7.06561 21.2188C7.06561 20.2617 7.84152 19.4858 8.79865 19.4858C9.75578 19.4858 10.5317 20.2617 10.5317 21.2188C10.5317 22.1759 9.75578 22.9519 8.79865 22.9519Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9081 22.9519C17.9509 22.9519 17.175 22.1759 17.175 21.2188C17.175 20.2617 17.9509 19.4858 18.9081 19.4858C19.8652 19.4858 20.6411 20.2617 20.6411 21.2188C20.6411 22.1759 19.8652 22.9519 18.9081 22.9519Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.dfd180e7b4c64b04b8c22ccd918d2417.svg";
export { ForwardRef as ReactComponent };